export default "__VITE_ASSET__uxHSr8KA__"